import React, { useState } from 'react';
import { X, Eye, Plus, Clock, Globe, Pin, Crown } from 'lucide-react';
interface Template {
  id: string;
  title: string;
  category: string;
  language: 'EN' | 'FR';
  flag: string;
  isPremium: boolean;
  description?: string;
  summary?: string;
  lastUpdated?: string;
}
interface TemplateDetailsSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  template: Template | null;
  onViewSample: () => void;
  onCreateDocument: () => void;
  documentsLeft?: number;
}
export function TemplateDetailsSidebar({
  isOpen,
  onClose,
  template,
  onViewSample,
  onCreateDocument,
  documentsLeft = 47
}: TemplateDetailsSidebarProps) {
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
  if (!isOpen || !template) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/30 z-40 transition-opacity" onClick={onClose} data-id="element-832" />

      {/* Sidebar */}
      <div className="fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl z-50 flex flex-col" data-id="element-833">
        {/* Header */}
        <div className="p-6 border-b border-borderColor" data-id="element-834">
          <div className="flex items-start justify-between mb-4" data-id="element-835">
            <h2 className="text-xl font-bold text-primary pr-8" data-id="element-836">
              {template.title}
            </h2>
            <div className="flex items-center gap-1 flex-shrink-0" data-id="element-837">
              <button className="p-2 hover:bg-aliceBlue rounded-lg transition-colors" title="Pin template" data-id="element-838">
                <Pin className="w-5 h-5 text-secondary" data-id="element-839" />
              </button>
              <button onClick={onClose} className="p-2 hover:bg-aliceBlue rounded-lg transition-colors" data-id="element-840">
                <X className="w-5 h-5 text-secondary" data-id="element-841" />
              </button>
            </div>
          </div>

          {/* Meta Information */}

          <div className="flex items-center justify-between text-sm" data-id="element-842">
            <div className="flex items-center gap-1" data-id="element-843">
              <Globe className="w-4 h-4 text-secondary" data-id="element-844" />
              <span className="text-secondary text-xs font-semibold" data-id="element-845">CA</span>
              <span className="text-secondary" data-id="element-846">EN</span>
            </div>

            <div className="flex items-center gap-1" data-id="element-847">
              <Clock className="w-4 h-4 text-secondary" data-id="element-848" />
              <span className="text-secondary" data-id="element-849">
                Last Updated {template.lastUpdated || '2025-10-07'}
              </span>
            </div>
          </div>

          {/* Category + Premium Badge */}
          <div className="mt-3 flex items-center gap-2" data-id="element-850">
            {template.isPremium && <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-amber-50 text-amber-700 border border-amber-200 rounded-lg text-sm font-medium" data-id="element-851">
                <Crown className="w-3.5 h-3.5" data-id="element-852" />
                Premium
              </span>}
            <span className="inline-block px-3 py-1.5 bg-aliceBlue text-primary rounded-lg text-sm font-medium" data-id="element-853">
              {template.category}
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6" data-id="element-854">
          {/* Description */}
          <div data-id="element-855">
            <p className="text-sm text-primary leading-relaxed" data-id="element-856">
              This plain-language privacy policy helps Canadian small businesses
              comply with the federal Personal Information Protection and
              Electronic Documents Act (PIPEDA) and similar provincial privacy
              laws. It outlines what personal information is collected, how it's
              used and protected, when it may be shared, and what rights
              individuals have.
            </p>
            <p className="text-sm text-primary leading-relaxed mt-3" data-id="element-857">
              It's designed for use on a company's website or as part of
              customer onboarding materials, ensuring transparency while
              remaining easy to implement.
            </p>
            <p className="text-sm text-primary leading-relaxed" data-id="element-858">
              This plain-language privacy policy helps Canadian small businesses
              comply with the federal Personal Information Protection and
              Electronic Documents Act (PIPEDA) and similar provincial privacy
              laws. It outlines what personal information is collected, how it's
              used and protected, when it may be shared, and what rights
              individuals have.
            </p>
            <p className="text-sm text-primary leading-relaxed mt-3" data-id="element-859">
              It's designed for use on a company's website or as part of
              customer onboarding materials, ensuring transparency while
              remaining easy to implement.
            </p>
            <p className="text-sm text-primary leading-relaxed" data-id="element-860">
              This plain-language privacy policy helps Canadian small businesses
              comply with the federal Personal Information Protection and
              Electronic Documents Act (PIPEDA) and similar provincial privacy
              laws. It outlines what personal information is collected, how it's
              used and protected, when it may be shared, and what rights
              individuals have.
            </p>
            <p className="text-sm text-primary leading-relaxed mt-3" data-id="element-861">
              It's designed for use on a company's website or as part of
              customer onboarding materials, ensuring transparency while
              remaining easy to implement.
            </p>
            <p className="text-sm text-primary leading-relaxed" data-id="element-862">
              This plain-language privacy policy helps Canadian small businesses
              comply with the federal Personal Information Protection and
              Electronic Documents Act (PIPEDA) and similar provincial privacy
              laws. It outlines what personal information is collected, how it's
              used and protected, when it may be shared, and what rights
              individuals have.
            </p>
            <p className="text-sm text-primary leading-relaxed mt-3" data-id="element-863">
              It's designed for use on a company's website or as part of
              customer onboarding materials, ensuring transparency while
              remaining easy to implement.
            </p>
            <p className="text-sm text-primary leading-relaxed" data-id="element-864">
              This plain-language privacy policy helps Canadian small businesses
              comply with the federal Personal Information Protection and
              Electronic Documents Act (PIPEDA) and similar provincial privacy
              laws. It outlines what personal information is collected, how it's
              used and protected, when it may be shared, and what rights
              individuals have.
            </p>
            <p className="text-sm text-primary leading-relaxed mt-3" data-id="element-865">
              It's designed for use on a company's website or as part of
              customer onboarding materials, ensuring transparency while
              remaining easy to implement.
            </p>
            <p className="text-sm text-primary leading-relaxed" data-id="element-866">
              This plain-language privacy policy helps Canadian small businesses
              comply with the federal Personal Information Protection and
              Electronic Documents Act (PIPEDA) and similar provincial privacy
              laws. It outlines what personal information is collected, how it's
              used and protected, when it may be shared, and what rights
              individuals have.
            </p>
            <p className="text-sm text-primary leading-relaxed mt-3" data-id="element-867">
              It's designed for use on a company's website or as part of
              customer onboarding materials, ensuring transparency while
              remaining easy to implement.
            </p>
          </div>
        </div>

        {/* Footer - Disclaimer + Actions (sticky) */}
        <div className="border-t border-borderColor bg-white flex-shrink-0" data-id="element-868">
          {/* Disclaimer */}
          <div className="px-6 pt-4 pb-3" data-id="element-869">
            <p className="text-xs text-secondary leading-relaxed mb-3" data-id="element-870">
              By using the LawVo Document Center, and as set out in our{' '}
              <a href="https://lawvo.com/terms-conditions/" target="_blank" rel="noopener noreferrer" className="text-turquoise hover:underline" data-id="element-871">
                Terms of Use
              </a>{' '}
              and{' '}
              <a href="https://lawvo.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-turquoise hover:underline" data-id="element-872">
                Privacy Policy
              </a>
              , you acknowledge that all documents are template-based and
              intended as a starting point only; limited customization may not
              reflect your specific circumstances or applicable provincial laws.
              The materials are for general information only and do not
              constitute legal advice, you should have documents reviewed and
              finalized by a qualified legal professional before relying on it.
            </p>
            <label className="flex items-center gap-2 cursor-pointer" data-id="element-873">
              <input type="checkbox" checked={disclaimerAccepted} onChange={e => setDisclaimerAccepted(e.target.checked)} className="w-4 h-4 rounded border-borderColor text-turquoise focus:ring-turquoise/20 flex-shrink-0" data-id="element-874" />
              <span className="text-xs font-medium text-primary" data-id="element-875">
                I acknowledge and accept the above disclaimer
              </span>
            </label>
          </div>

          {/* Action Buttons */}
          <div className="px-6 pb-6" data-id="element-876">
            <div className="flex gap-3" data-id="element-877">
              <button onClick={onViewSample} className="flex-1 px-4 py-3 border border-borderColor text-primary rounded-lg hover:bg-aliceBlue transition-colors text-sm font-medium flex items-center justify-center gap-2" data-id="element-878">
                <Eye className="w-4 h-4" data-id="element-879" />
                VIEW SAMPLE
              </button>
              <button onClick={onCreateDocument} disabled={!disclaimerAccepted} className={`flex-1 px-4 py-3 rounded-lg transition-colors text-sm font-medium flex items-center justify-center gap-2 ${disclaimerAccepted ? 'bg-turquoise text-white hover:bg-turquoise/90' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-880">
                <Plus className="w-4 h-4" data-id="element-881" />
                CREATE DOCUMENT
                <span className={`ml-1 px-2 py-0.5 rounded text-xs font-medium ${disclaimerAccepted ? 'bg-white/20' : 'bg-gray-300/50'}`} data-id="element-882">
                  {documentsLeft} left
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>;
}